// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from "../AppCredential/AppCredential";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

function Run({ action, variables, setOpenVariable, automId, setAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.MY-CHATGPT.RUN.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [outLabel, setOutLabel] = useState({ isOk: false, value: "" });

    useEffect(() => {
        if (action.fields?.label) {
            setOutLabel({ isOk: true, value: action.fields.label.value })
        }
    }, [action?.fields?.label?.value])

    const updateLabel = (id, items) => {
        let isDifferentLabel
        const innerUpdateLabel = (id, items) => {
            items.forEach(item => {
                if (item.id === id) {
                    item.fields = action.fields;
                    if (item.label !== action.fields.label.value && (item.label !== undefined || action.fields.label.value)) {
                        item.label = action.fields.label.value;
                        isDifferentLabel = true
                    }
                } else if (item.children) {
                    innerUpdateLabel(id, item.children);
                }
            });
        }
        innerUpdateLabel(id, items)
        return isDifferentLabel
    };

    return (
        <div>
            <AppCredential action={action} setAlert={setAlert}/>
            <div className="form-element">
                <FieldLabel name={t(label + 'ASSISTANT-ID')} is_required/>
                <TextInput action={action} inputName="assistantId" variables={variables}
                           setOpenVariable={setOpenVariable}
                           fieldType="string" displayName={t(label + 'ASSISTANT-ID')} isRequired hideRequired/>
                <small
                    className="conf-field-desc"><em>{t(label + 'ASSISTANT-ID-HELPER', {type: 'string'})}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'RESPONSE')}/>
                <VariablePicker action={action} inputName="set" variables={variables}
                                setOpenVariable={setOpenVariable}
                                filter="string"/>
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.FIELD-MUST-BE-STRING-TYPE')}</em></small>
            </div>
        </div>
    );
}

export default Run;
